<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="analyte-result-server-table"
      class="w-100"
    >
      <span slot="analyte" slot-scope="{ row }">
        <existence-gate :entity="row" :levels="['analyte']" :field="'name'">
          <template #existing-content>
            <router-link
              :to="`/result-manager/${row.id}`"
            >
              {{ formatAnalyteName(row.analyte) }}
            </router-link>
          </template>
        </existence-gate>
      </span>
      <span slot="instrument_instance.instrument.name" slot-scope="{ row }">
        <existence-gate
          :entity="row"
          :levels="table_data.instrument"
          :field="'name'"
        >
          <template #existing-content>
            {{ getData(row, { levels: table_data.instrument, field: "name" }) }}
          </template>
        </existence-gate>
      </span>
      <span slot="result" slot-scope="{ row }">
        <existence-gate :entity="row" :levels="['analyte']" :field="'name'">
          <template #existing-content>
            {{ getResultInfo(row) }}
          </template>
        </existence-gate>
      </span>
      <span slot="status" slot-scope="{ row }">
        <existence-gate
          :entity="row"
          :levels="table_data.status"
          :field="'status'"
        >
          <template #existing-content>
            <b-badge
              v-if="
                getData(row, { levels: table_data.status, field: 'status' }) ===
                'Pending'
              "
              variant="warning"
              pill
              >Pending</b-badge
            >
            <b-badge
              v-if="
                getData(row, { levels: table_data.status, field: 'status' }) ===
                'Declined'
              "
              variant="danger"
              pill
              >Declined</b-badge
            >
            <b-badge
              v-if="
                getData(row, { levels: table_data.status, field: 'status' }) ===
                'Approved'
              "
              variant="success"
              pill
              >Approved</b-badge
            >
          </template>
        </existence-gate>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import AnalyteResultCollection from "@/collections/lab/AnalyteResultCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import { ServerTable } from "vue-tables-2";
import { getEntityData, formatAnalyteName } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "AnalyteResultServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new AnalyteResultCollection(),
    },
    show_columns: {
      type: Array,
      default: () => [
        "analyte",
        "instrument_instance.instrument.name",
        "result",
        "created_by.name",
        "evaluated_by.name",
        "status",
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["instrument_instance.instrument.name"],
    },
  },
  data() {
    return {
      sample_id: this.$route.params.sample_id || null,
      table_config: this.lodash.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            "instrument_instance.instrument.name": "Instrument Name",
            "created_by.name": "Created By",
            "evaluated_by.name": "Evaluated By",
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
      table_data: {
        sample_type: ["analyte", "sample_type"],
        instrument: ["instrument_instance", "instrument"],
        status: ["current_analyte_result_status_log", "analyte_result_status"],
      },
    };
  },
  methods: {
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    formatAnalyteName(analyte) {
      return formatAnalyteName(analyte);
    },
    getResultInfo({ analyte, formatted_result, raw_result, unit_of_measure }) {
      const unit = unit_of_measure ? unit_of_measure.abbrev : "";

      return analyte && analyte.name === "Completion"
        ? raw_result
          ? "Completed"
          : "Not-Complete"
        : `${formatted_result}${unit}(${Number(raw_result)}${unit})`;
    },
    prepareCollectionFilter(filter) {
      const connections = [
        "analyte.sample_type",
        "sample",
        "created_by",
        "instrument_instance.instrument",
        "unit_of_measure",
        "current_analyte_result_status_log.analyte_result_status",
      ];

      connections.forEach((connection) => {
        filter.connectionAdd(connection);
      });

      this.sample_id && filter.filterEquals("sample_id", this.sample_id);

      return filter;
    },
  },
};
</script>
